import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import JoinRoompage from "./joinroompage/JoinRoompage";
import Roompage from "./roompage/Roompage";
import Dashboard from "./dashboard/Dashboard";
import Login from "./login/Login";
import Users from "./users/Users";
import { connectWithSocketIOServer } from "./utils/wss";
import { messaging } from "./utils/firebase-messaging"; // 👈 import your Firebase messaging setup
import { onMessage } from "firebase/messaging"; // 👈 Firebase foreground handler
import "./App.css";
import { stopRingtone } from "./utils/ringtone";
import { getSocket } from "./utils/wss";
import { confirmAlert } from "react-confirm-alert";

function App() {
  useEffect(() => {
    console.log("Connecting to Socket.IO server...");
    connectWithSocketIOServer();

    // 👂 Foreground FCM listener (direct from Firebase)
    onMessage(messaging, (payload) => {
      console.log("📬 Foreground message from Firebase:", payload);
      const data = payload.data;
      if (data?.type === "ring") {
        // Show UI alert, sound, toast, etc.
        alert(`🔔 Incoming call from ${data.fromName}`);
        // Optionally play sound or open popup
      }
    });

    // 👂 Background message via service worker -> forwarded to client
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NEW_NOTIFICATION") {
          console.log("📩 Message from service worker:", event.data.data);
          const data = event.data.data;
          if (data.type === "ring") {
            alert(`📞 Incoming call from ${data.fromName}`);
          }
        }
      });
    }
  }, []);
  

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={Users} />
        <Route path="join-room" Component={JoinRoompage} />
        <Route path="room" Component={Roompage} />
        <Route path="login" Component={Login} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
